<script setup lang="ts">
import logo from '#ui-shared/assets/img/nora-chat-logo.png';
import splashScreen from '#ui-shared/assets/img/splash-screen.desktop.jpg';

interface SplashScreenProps {
  text?: string;
  noraFull?: boolean;
}

withDefaults(defineProps<SplashScreenProps>(), {
  noraFull: false,
  text: '',
});
</script>

<template>
  <div v-if="!noraFull" class="data-loading">
    <img :src="logo" alt="">

    <div v-if="text" class="font-semibold text-white">
      {{ text }}
    </div>
  </div>
  <div v-else class="w-full h-full">
    <img :src="splashScreen" class="w-full h-full object-cover">
  </div>
</template>

<style scoped>
.data-loading {
  background: linear-gradient(33deg, #060c0f, #2c5387);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text {
  font-family: 'Source Sans Pro', sans-serif;
}
</style>
